// extracted by mini-css-extract-plugin
export default {"container":"eJy5Xcnd0JyKH3zvyRTG","image":"FkxQsykPcmBexJAkm8un","textBlock":"dfhtl6ORTEY6MpYdIqdA"};